(() => {
  const root = document.body.dataset.root || '/';
  const strings = JSON.parse(document.getElementById('ThemeStrings')?.textContent || '{}');
  const status = text => { const el = document.getElementById('SiteStatus'); if (el) el.textContent = text; };
  const parse = text => new DOMParser().parseFromString(text, 'text/html');
  const request = async (url, options = {}) => { const response = await fetch(url, options); const data = await response.json(); if (!response.ok || data.status >= 400) throw new Error(data.description || strings.error); return data; };
  const openDialog = (dialog, trigger) => { if (!dialog) return; dialog.returnFocus = trigger || document.activeElement; dialog.showModal(); };
  const closeDialog = dialog => { dialog?.close(); dialog?.returnFocus?.focus(); };
  document.addEventListener('close', event => { if (event.target instanceof HTMLDialogElement) event.target.returnFocus?.focus(); }, true);
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-close]');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target instanceof HTMLDialogElement) { const r = event.target.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target); }
    const filterClose = event.target.closest('[data-filter-close]');
    if (filterClose) { const d = filterClose.closest('details'); d.open = false; d.querySelector('summary').focus(); }
    const back = event.target.closest('[data-back]');
    if (back) { const d = back.closest('details'); d.open = false; d.querySelector('summary')?.focus(); }
    if (event.target.closest('[data-print]')) window.print();
    const share = event.target.closest('[data-share]');
    if (share) { try { if (navigator.share) await navigator.share({ title: document.title, url: location.href }); else { await navigator.clipboard.writeText(location.href); share.parentElement.querySelector('.share-status').textContent = location.href; } } catch {} }
    const cart = event.target.closest('[data-open-cart]');
    if (cart && document.body.dataset.cartDrawer === 'true') { event.preventDefault(); openDialog(document.getElementById('CartDrawer'), cart); }

    const quickView = event.target.closest('[data-quick-view]');
    if (quickView) {
      event.preventDefault();
      const dialog = document.getElementById('QuickViewDialog');
      const content = dialog?.querySelector('[data-quick-view-content]');
      const loading = dialog?.querySelector('[data-quick-view-loading]');
      const error = dialog?.querySelector('[data-quick-view-error]');
      if (!dialog || !content || !loading || !error) return;
      content.replaceChildren();
      loading.hidden = false;
      error.hidden = true;
      error.textContent = '';
      quickView.setAttribute('aria-busy','true');
      if (!dialog.open) openDialog(dialog, quickView);
      else dialog.returnFocus = quickView;
      try {
        const url = new URL(quickView.dataset.quickView, location.origin);
        url.searchParams.set('section_id','quick-view-product');
        const response = await fetch(url.toString(), { headers:{ Accept:'text/html' } });
        if (!response.ok) throw new Error(strings.error);
        const next = parse(await response.text()).querySelector('[data-quick-view-product]');
        if (!next) throw new Error(strings.error);
        content.replaceChildren(next);
      } catch (err) {
        error.textContent = err.message || strings.error;
        error.hidden = false;
      } finally {
        loading.hidden = true;
        quickView.removeAttribute('aria-busy');
      }
      return;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      const panel = event.target.closest('.filter-drawer[open],.mobile-nav[open]');
      if (panel && matchMedia('(max-width:749px)').matches) {
        const focusable = [...panel.querySelectorAll('a,button,input,select,textarea,summary')].filter(el=>!el.disabled && el.getClientRects().length);
        const first=focusable[0],last=focusable.at(-1);
        if (event.shiftKey && event.target===first) {event.preventDefault();last?.focus();}
        else if (!event.shiftKey && event.target===last) {event.preventDefault();first?.focus();}
      }
    }
    if (event.key !== 'Escape') return;
    const details = event.target.closest('details[open]');
    if (details) { details.open = false; details.querySelector('summary')?.focus(); }
  });
  const initMenus = (scope = document) => {
    scope.querySelectorAll('.mega').forEach(menu => {
      if (menu.dataset.ready) return; menu.dataset.ready = 'true';
      let timer;
      menu.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) { clearTimeout(timer); document.querySelectorAll('.mega[open]').forEach(other => { if (other !== menu) other.open = false; }); menu.open = true; } });
      menu.addEventListener('mouseleave', () => { timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180); });
      menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 0));
      menu.addEventListener('toggle', () => { if (menu.open) document.querySelectorAll('.mega[open]').forEach(other => { if (other !== menu) other.open = false; }); });
    });
    scope.querySelectorAll('.filter-drawer').forEach(el => { if (!el.dataset.ready) { el.dataset.ready = 'true'; el.open = matchMedia('(min-width:750px)').matches; } });
  };
  initMenus();
  document.addEventListener('shopify:section:load', event => initMenus(event.target));
  document.addEventListener('click', event => document.querySelectorAll('.mega[open],.mobile-nav[open]').forEach(d => { if (!d.contains(event.target)) d.open = false; }));
  let cartBusy = false;
  async function refreshCart() {
    const data = await request(`${root}?sections=cart,cart-drawer`);
    for (const [key, html] of Object.entries(data)) {
      if (!html) throw new Error(strings.error);
      const context = key === 'cart' ? 'page' : 'drawer';
      const current = document.querySelector(`[data-cart-content="${context}"]`);
      const next = parse(html).querySelector(`[data-cart-content="${context}"]`);
      if (current && next) current.replaceChildren(...next.childNodes);
    }
    const cart = await request(`${root}cart.js`);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    window.Shopify?.PaymentButton?.init();
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.ajax-product-form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy || form.closest('[aria-busy=true]')) return;
    const button = event.submitter || form.querySelector('[type=submit]');
    const buyNow = button.hasAttribute('data-buy-now');
    if (button.disabled) return;
    const error = form.querySelector('.form-error');
    form.dataset.busy = 'true'; button.disabled = true; error.textContent = '';
    let added = false;
    try {
      await request(`${root}cart/add.js`, { method:'POST', body:new FormData(form), headers:{ Accept:'application/json' } });
      added = true;
      if (buyNow) { location.assign(root + 'checkout'); return; }
      if (document.body.dataset.cartDrawer !== 'true') { location.assign(`${root}cart`); return; }
      await refreshCart();
      status(strings.added);
      const quickViewDialog = form.closest('#QuickViewDialog');
      const cartTrigger = quickViewDialog?.returnFocus || button;
      if (quickViewDialog?.open) quickViewDialog.close();
      openDialog(document.getElementById('CartDrawer'), cartTrigger);
    } catch (err) { if (added) location.assign(`${root}cart`); else error.textContent = err.message || strings.error; }
    finally { delete form.dataset.busy; button.disabled = false; }
  });
  async function updateCart(el, payload) {
    if (cartBusy) return; cartBusy = true;
    const form = el.closest('.cart-form');
    const focusKey = el.dataset.cartQuantity;
    form.setAttribute('aria-busy','true');
    try { await request(`${root}cart/change.js`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) }); await refreshCart(); status(strings.updated); if (focusKey) [...document.querySelectorAll('[data-cart-quantity]')].find(input => input.dataset.cartQuantity === focusKey)?.focus(); }
    catch (err) { form.querySelector('.cart-error').textContent = err.message || strings.error; }
    finally { form.removeAttribute('aria-busy'); cartBusy = false; }
  }
  document.addEventListener('change', event => { const el = event.target.closest('[data-cart-quantity]'); if (el && el.checkValidity()) updateCart(el, {id:el.dataset.cartQuantity,quantity:Number(el.value)}); });
  document.addEventListener('click', event => {
    const adjust = event.target.closest('[data-cart-adjust]');
    if (adjust) {
      event.preventDefault();
      if (cartBusy) return;
      const stepper = adjust.closest('.quantity-stepper');
      const input = stepper?.querySelector('[data-cart-quantity]');
      if (!input) return;
      const increment = Number(input.step) || 1;
      const next = Math.max(0, (Number(input.value) || 0) + (Number(adjust.dataset.cartAdjust) * increment));
      if (next === Number(input.value)) return;
      input.value = next;
      updateCart(input, {id:input.dataset.cartQuantity,quantity:next});
      return;
    }
    const el = event.target.closest('[data-remove]');
    if (el) { event.preventDefault(); updateCart(el, {id:el.dataset.remove,quantity:0}); }
  });
  document.addEventListener('change', async event => { if (!event.target.matches('.cart-form [name=note]')) return; try { await request(`${root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:event.target.value})}); } catch (err) { event.target.closest('form').querySelector('.cart-error').textContent = err.message; } });
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type=search]'); this.results = this.querySelector('.predictive-results'); this.index = -1;
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.controller?.abort(); this.close(); if (this.input.value.trim().length > 1) this.timer = setTimeout(() => this.search(), 220); });
      this.input.addEventListener('keydown', event => {
        const options = [...this.results.querySelectorAll('[role=option]')];
        if (event.key === 'Escape') { this.close(); return; }
        if (['ArrowDown','ArrowUp'].includes(event.key) && options.length && !this.results.hidden) { event.preventDefault(); this.index = (this.index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length; options.forEach((el,i) => el.setAttribute('aria-selected',String(i === this.index))); this.input.setAttribute('aria-activedescendant',options[this.index].id); options[this.index].scrollIntoView({block:'nearest'}); }
        if (event.key === 'Enter' && this.index >= 0 && !this.results.hidden) { event.preventDefault(); options[this.index]?.querySelector('a')?.click(); }
      });
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0));
      this.addEventListener('pointerdown', event => { if (event.target.closest('.predictive-results')) event.preventDefault(); });
    }
    close() { this.results.hidden = true; this.index = -1; this.input.setAttribute('aria-expanded','false'); this.input.removeAttribute('aria-activedescendant'); }
    async search() {
      const term = this.input.value.trim(); this.controller = new AbortController(); this.querySelector('[role=status]').textContent = strings.loading;
      try { const response = await fetch(`${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,article,page&resources[limit]=4&section_id=predictive-search`,{signal:this.controller.signal}); if (!response.ok) throw new Error(); const html = await response.text(); if (term !== this.input.value.trim()) return; const list = parse(html).querySelector('[role=listbox]'); if (!list) throw new Error(); this.results.replaceChildren(list); this.results.hidden = false; this.input.setAttribute('aria-expanded','true'); this.querySelector('[role=status]').textContent = ''; }
      catch (err) { if (err.name !== 'AbortError') { this.close(); this.querySelector('[role=status]').textContent = ''; } }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  }
  class ProductCarousel extends HTMLElement {
    connectedCallback() { if (this.ready) return; this.ready = true; const track = this.querySelector('[data-track]'); this.querySelector('[data-prev]')?.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})); this.querySelector('[data-next]')?.addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})); }
  }
  class Recommendations extends HTMLElement {
    async connectedCallback() { if(this.dataset.loaded)return; this.dataset.loaded='true'; try { const response=await fetch(this.dataset.url); if(!response.ok)return; const el=parse(await response.text()).querySelector('product-recommendations'); if(el?.querySelector('.product-card')){this.innerHTML=el.innerHTML;this.hidden=false;} }catch{} }
  }
  for (const [name,cls] of [['predictive-search',PredictiveSearch],['product-carousel',ProductCarousel],['product-recommendations',Recommendations]]) if(!customElements.get(name))customElements.define(name,cls);
})();
